import { logo } from "assets/images";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.scss";
import Avatar from "./Avatar";
import { getFromLocal, setToLocal } from "config/axiosInstance";
import { FaBars, FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { KSAIcon, USAIcon } from "assets/icons";
import i18next from "i18next";
import { Dropdown } from "react-bootstrap";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about-us", label: "About Us" },
  { to: "/pricing", label: "Pricing" },
  { to: "/features", label: "Features" },
  { to: "/contact-us", label: "Contact Us" },
];

const Header = () => {
  const [scroll, setScroll] = useState(false);
  const loginToken = getFromLocal();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [language, setLanguage] = useState(i18next?.language || "en");
  const { t, i18n } = useTranslation();

  const getLanguage = (language) => {
    const languageObject = {
      en: {
        icon: USAIcon,
        label: "English",
      },
      ar: {
        icon: KSAIcon,
        label: "Arabic",
      },
    };

    return languageObject[language] || languageObject["en"];
  };

  const handleLanguageChange = (selectedLanguage) => {
    setToLocal("i18nLng", selectedLanguage, null);
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  useEffect(() => {
    document.body.classList.toggle("mobile_open", mobileMenu);
  }, [mobileMenu]);

  return (
    <>
      <header className={`header ${scroll ? "scrolledHeader" : ""}`}>
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
          <nav className="header_nav">
            <ul>
              {navLinks.map((link, index) => (
                <li key={link?.to || index}>
                  <NavLink to={link?.to || ""}>
                    {t(`HOME-HEADER.${link?.label}`) || ""}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
          <div className="right_button_wrap">
            {!loginToken ? (
              <div className="right_button">
                <Dropdown className="customDropdown language_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <img src={getLanguage(language)?.icon} alt="" />{" "}
                    <span>{getLanguage(language)?.label}</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => handleLanguageChange("en")}
                      // href="#/action-1"
                    >
                      <img src={USAIcon} alt="" /> <span>EN</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleLanguageChange("ar")}
                      // href="#/action-2"
                    >
                      <img src={KSAIcon} alt="" /> <span>AR</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Link to="/login">{t("HOME-HEADER.login")}</Link>
                <Link to="/signup" className="get_start button">
                  {t("HOME-HEADER.getStarted")}
                </Link>
              </div>
            ) : (
              <Avatar />
            )}
            <button
              type="button"
              className="mobile_button"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {mobileMenu ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </header>
      <div className="overlay" onClick={() => setMobileMenu(false)}></div>
    </>
  );
};

export default Header;
